import React from "react";
import localeText from "../../../../../../locale";

const InviteCouponDialogHeader = ({ step, onClose }) => (
  <div
    className="flex justify-content-between align-items-start gap-3 mb-3 pb-3 border-bottom-1"
    style={{ borderColor: "var(--theme-border, #EBEBEB)" }}
  >
    <div>
      <h2 className="text-lg font-semibold m-0" style={{ color: "var(--theme-text, #172B4D)" }}>
        {localeText("inviteCouponDialogTitle")}
      </h2>
      {step === 1 && (
        <p className="text-sm m-0 mt-2" style={{ color: "var(--theme-text-muted, #5C5C5C)" }}>
          {localeText("inviteCouponDialogSubtitle")}
        </p>
      )}
    </div>
    <button
      type="button"
      className="p-button p-component p-button-text p-button-rounded p-2 p-no-outline"
      onClick={onClose}
      aria-label={localeText("inviteCouponCancel")}
    >
      <i className="pi pi-times" />
    </button>
  </div>
);

export default InviteCouponDialogHeader;
